// Default per-column width floors (px) for a SimpleTable opted into `columnMinWidths`.
export const FIRST_COLUMN_MIN_WIDTH = 200;
export const COLUMN_MIN_WIDTH = 120;

// Frozen first-column cells paint above their row; the pinned header copy paints above them.
export const FROZEN_CELL_Z_INDEX = 1;
export const PINNED_HEADER_Z_INDEX = 2;
